import { render, staticRenderFns } from "./BulkArticleActioner.vue?vue&type=template&id=5bce9c09&"
import script from "./BulkArticleActioner.vue?vue&type=script&lang=js&"
export * from "./BulkArticleActioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports